<template>
  <div class="base-select-native w-100">
    <vue-select
      :multiple="isMultiple"
      label="text"
      :placeholder="placeholder"
      v-model="localValue"
      :options="options"
      :style="styleCustom"
    />
  </div>
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "SelectSearch",
  components: { VueSelect },
  props: {
    label: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "Select option",
    },
    options: {
      type: Array,
      default: () => [],
    },

    value: {
      type: [Object, String, Number],
      default: null,
    },

    isMultiple: {
      type: Boolean,
      default: false,
    },
    styleCustom: {
      type: String,
      default: "",
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(payload) {
        this.$emit("update:value", payload);
      },
    },
  },
};
</script>
